import { isEmpty } from 'lodash';
export class Endereco {
  public idTipoEndereco = 0;
  public uf = '';
  public cidade = '';
  public endereco = '';
  public bairro = '';
  public numero = '';
  public complemento = '';
  public cep = '-';
  public condicaoResidencia = '';
  public condicaoResidenciaOutro = '';
  public tempoResidencia = '';

  constructor(data?: any) {
    this.idTipoEndereco = (data || {}).idTipoEndereco;
    this.uf = (data || {}).uf;
    this.cidade = (data || {}).cidade;
    this.endereco = (data || {}).endereco;
    this.bairro = (data || {}).bairro;
    this.numero = (data || {}).numero;
    this.complemento = (data || {}).complemento;
    this.cep = (data || {}).cep;
    this.condicaoResidencia = !isEmpty((data || {}).condicaoResidencia) ? (data || {}).condicaoResidencia : undefined;
    this.condicaoResidenciaOutro = !isEmpty((data || {}).condicaoResidenciaOutro) ? (data || {}).condicaoResidenciaOutro : undefined;
    this.tempoResidencia = !isEmpty((data || {}).tempoResidencia) ? (data || {}).tempoResidencia : undefined;
  }

  get $cep() {
    if (this.cep) {
      return this.cep.replace('-', '');
    }
  }
  get $idTipoEndereco() {
    return this.idTipoEndereco === 2 ? this.idTipoEndereco : 1;
  }
}
